import cn from "clsx";
import { useMemo } from "react";
import styles from "./CommonStyles.module.css";

type AlignmentContainerProps = Readonly<{
  children: React.ReactNode;
  align: "left" | "center" | "right";
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  className?: string;
}>;

export const AlignmentContainer = ({
  align,
  children,
  wrapperClassName,
  wrapperStyle,
  className,
}: AlignmentContainerProps) => {
  const justifyContent = useMemo(() => {
    switch (align) {
      case "left":
        return "flex-start";
      case "center":
        return "center";
      case "right":
        return "flex-end";
      default:
        throw new Error(`Unknown align value: ${align}`);
    }
  }, [align]);

  return (
    <div
      className={cn(className, styles.alignmentContainer)}
      style={{
        justifyContent,
      }}
    >
      <div
        style={{
          ...wrapperStyle,
        }}
        className={wrapperClassName}
      >
        {children}
      </div>
    </div>
  );
};
